export default __webpack_public_path__ + "static/media/sidebar-3.3f8bff1f.jpg";